import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { SecurepayNotification } from '../notification.model';

@Component({
  selector: 'app-notification-item',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './notification-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationItemComponent {
  readonly notification = input.required<SecurepayNotification>();

  readonly onAccept = output<SecurepayNotification>();
  readonly onDecline = output<SecurepayNotification>();

  protected accept(): void {
    this.onAccept.emit(this.notification());
  }

  protected decline(): void {
    this.onDecline.emit(this.notification());
  }
}
